<template>
    <span>
        <span v-for="boost in boostsNeeded">
            <img v-bind:class="{ 'noMatch': !showAll && isMatch(boost) }" :src="`/static/img/icons/${boost}.png`" :width="width">
        </span>
    </span>
</template>

<script>
    //import TWEEN from '@tweenjs/tween.js'
    export default {
        name: 'elv-matching-boosts',
        props: {
            'boostsNeeded': {required:true},
            'showAll': {required:false, default: false, type:Boolean},
            'player': {required:false},
            'width': {required: false, default: 24}
        },
        created() {
            console.log("player.boost1" + player.boost1 );
        },
        methods: {
            isMatch: function(boost) {
                return boost !== this.player.boost1 && boost !== this.player.boost2 && boost !== this.player.boost3
            }
        }
    }
</script>


<style scoped>
    .noMatch {
        opacity: 0.5;
        filter: gray; /* IE6-9 */
        -webkit-filter: grayscale(1); /* Google Chrome, Safari 6+ & Opera 15+ */
        filter: grayscale(1); /* Microsoft Edge and Firefox 35+ */
    }

    /* Disable grayscale on hover */
    .noMatch:hover {
        -webkit-filter: grayscale(0);
        filter: none;
    }

</style>



// WEBPACK FOOTER //
// src/components/ElvMatchingBoosts.vue